import { Box, CircularProgress, Typography } from "@mui/material";
import React, { FC } from "react";
import { ButtonProps } from "../types";
import { useMediaQuery } from "@mui/material";

const Button: FC<ButtonProps> = ({
  primary,
  text,
  onClick,
  loading,
  width,
  secondary,
  height,
  margin,
  disable,
  display,
  id,
  fontSize,
  className,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <Box
      id={id}
      onClick={onClick}
      className={className}
      sx={{
        display: display ? display : "flex",
        padding:
          text === "Sign Up"
            ? isMobile
              ? "10px "
              : "8px 16px"
            : isMobile
            ? "10px"
            : "8px 26px",
        margin: margin
          ? margin
          : text === "Sign Up" || text === "Create"
          ? "0"
          : "0 20px",
        background:
          primary && !disable
            ? "linear-gradient(90deg, #FF5D22 0%, #FB8C64 100%)"
            : secondary
            ? "linear-gradient(90deg, #034C80 0%, #2D98E2 100%);"
            : disable
            ? "#BDBDBD"
            : "none",
        boxShadow: disable
          ? "0px 1px 4px rgba(0, 0, 0, 0.1)"
          : "0px 4px 12px rgba(0, 0, 0, 0.2)",
        borderRadius: "4px",
        cursor: loading || disable ? "not-allowed" : "pointer",
        border: disable
          ? "none"
          : secondary
          ? "none"
          : !primary
          ? "1px solid #FF6C37"
          : "none",
        pointerEvents: loading || disable ? "none" : "auto",
        width: width ? width : "auto",
        alignItems: "center",
        justifyContent: "center",
        height,
      }}
    >
      {loading ? (
        <CircularProgress
          sx={{
            color: "white",
            height: "20px !important",
            width: "20px !important",
          }}
        />
      ) : (
        <Typography
          sx={{
            fontFamily: "Lato",
            color: secondary || primary || disable ? "white" : "#FF6C37",
            fontSize: fontSize ? fontSize : "1rem",
          }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default Button;
